export default __webpack_public_path__ + "static/media/step3.6bb91ec0.webp";